<div class="map-container" [class.mobile]="isMobileView" [class.dragging]="isDraggingMap || isDraggingRedMarker">
  
  @if (!readonly) {
  <div class="map-instructions">
    <h4 class="instructions-title">{{ 'map.instructions.title' | translate }}</h4>
    <div class="instruction-steps">
      <div class="instruction-step required">
        <span class="step-text">{{ 'map.instructions.step1' | translate }}</span>
      </div>

    </div>
  </div>
  }
  <div class="map-legend">
    @if (lastPosition) {
    <div class="legend-item">
      <img src="assets/marker-icon.svg" class="legend-marker" alt="Marker blu">
      <span>{{ 'map.legend.vehiclePosition' | translate }}</span>
    </div>
    }
    <div class="legend-item">
      <img src="assets/marker-icon-red.svg" class="legend-marker" alt="Marker rosso">
      <span>{{ 'field.accidentPosition' | translate }}</span>
    </div>
  </div>
    
  <div [id]="mapId" class="map-display" [style.height]="height"></div>
  
</div>